var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendarDay05 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2zM9 5h6v2h2V5h3v14H4V5h3v2h2zm1.264 4.602-.391 3.27 1.178.276q.255-.334.773-.334.915 0 .914 1.024 0 1.107-.747 1.107a.7.7 0 0 1-.531-.206q-.202-.207-.225-.558H9.75q-.005.545.294.98.3.43.827.68.527.247 1.129.247.677 0 1.173-.268.497-.268.77-.765.276-.501.276-1.116 0-1.02-.514-1.582-.51-.567-1.463-.567-.246 0-.506.07-.255.07-.413.163l.145-1.27h2.536V9.602z",
  clipRule: "evenodd"
})));
export default SvgCalendarDay05;